export default class ForgotPasswordModel {
  email: string = '';
}
